<div *ngIf="planModel && tierModel && openIdProfile">
    <h3>
        Subscription Plan:
        <span
            class="cursor-pointer"
            [routerLink]="['/', 'subscriptions-plans', planModel.id, 'tiers']"
            ><i>{{ planModel.label }}</i></span
        >
        Tier
    </h3>

    <form [formGroup]="formGroup" (ngSubmit)="validate()">
        <div class="form-group">
            <label>Label</label>
            <input
                required
                formControlName="label"
                type="text"
                class="form-control form-control-sm"
                placeholder="Tier Label"
                [(ngModel)]="tierModel.label"
            />
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('label')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Sequence Number</label>
            <input
                required
                min="0"
                formControlName="sequence_number"
                type="number"
                class="form-control form-control-sm"
                placeholder="Sequence Number"
                [(ngModel)]="tierModel.sequence_number"
            />
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('sequence_number')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Description</label>
            <textarea
                required
                formControlName="description"
                class="form-control form-control-sm"
                placeholder="Description"
                [(ngModel)]="tierModel.description"
            ></textarea>
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('description')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Amount</label>
            <input
                min="0"
                required
                formControlName="amount"
                type="number"
                class="form-control form-control-sm"
                placeholder="Amount"
                [(ngModel)]="tierModel.amount"
            />
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('amount')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Period Unit</label>
            <select
                formControlName="period_unit"
                required
                class="form-control form-control-sm"
                placeholder="Period Unit"
                [(ngModel)]="tierModel.period_unit"
            >
                <option value="DAY">Day</option>
                <option value="WEEK">Week</option>
                <option value="MONTH">Month</option>
            </select>
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('period_unit')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Period Count</label>
            <input
                min="1"
                required
                formControlName="period_count"
                type="number"
                class="form-control form-control-sm"
                placeholder="Period Count"
                [(ngModel)]="tierModel.period_count"
            />
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('period_count')!.invalid"
            >
                Required
            </div>
        </div>

        <div class="form-group">
            <label>Cycle Count</label>
            <input
                min="0"
                required
                formControlName="cycles"
                type="number"
                class="form-control form-control-sm"
                placeholder="Cycle Count"
                [(ngModel)]="tierModel.cycles"
            />
            <div
                class="form-control-invalid"
                *ngIf="formGroup.get('cycles')!.invalid"
            >
                Required
            </div>
            <div class="text-primary">0 for recurring.</div>
        </div>

        <button type="submit" class="btn btn-primary btn-sm">Save</button>
        <span *ngIf="message">
            &nbsp;
            <button class="btn btn-secondary btn-sm">
                {{ message }}
            </button>
        </span>
    </form>
</div>

<div *ngIf="planModel" class="mt-2">
    <span
        class="cursor-pointer"
        [routerLink]="['/', 'subscriptions-plans', planModel.id, 'tiers']"
        >Back to plan {{ planModel.label }}</span
    >
</div>
